import { ReactElement, useContext } from "react";

import { CollectionsContext } from "../../providers/collections-provider";

import CollectionsSearchResult from "./collections-search-result";
import SharedCollections from "./shared-collections";
import YourCollections from "./your-collections";

export default function CollectionsList(): ReactElement {
  const { search } = useContext(CollectionsContext);

  return (
    <div className="shadow w-full rounded-[15px] p-50 bg-white gap-[20px] basis-[100%] flex-wrap flex flex-col content-start">
      {search ? (
        <CollectionsSearchResult />
      ) : (
        <>
          <YourCollections />
          <SharedCollections />
        </>
      )}
    </div>
  );
}
